import { render, staticRenderFns } from "./ReviewPastDonations.vue?vue&type=template&id=620160ef&scoped=true"
import script from "./ReviewPastDonations.vue?vue&type=script&lang=js"
export * from "./ReviewPastDonations.vue?vue&type=script&lang=js"
import style0 from "./ReviewPastDonations.vue?vue&type=style&index=0&id=620160ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620160ef",
  null
  
)

export default component.exports